import { on } from '@ember/modifier';
import { action } from '@ember/object';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import Button from './button';
import { downloadLogsUtil } from 'editor/utils/logger';

interface HelpPopupSignature {
  Element: HTMLFormElement;
  Args: {
    onClose: () => void;
  };
  Blocks: {
    // default: [];
  };
}

export default class HelpPopupComponent extends Component<HelpPopupSignature> {
  @tracked isSending = false;
  @tracked isSent = false;
  @tracked error: string | null = null;

  constructor(owner: unknown, args: HelpPopupSignature['Args']) {
    super(owner, args);
  }

  startSending() {
    this.isSending = true;
    this.isSent = false;
    this.error = null;
  }

  sendingComplete() {
    this.isSending = false;
    this.isSent = true;
    this.error = null;
  }

  errorSending(error: string) {
    this.isSending = false;
    this.isSent = false;
    this.error = error;
  }

  @action
  sendHelpRequest(ev: SubmitEvent) {
    ev.preventDefault();
    const form = <HTMLFormElement>ev.target;

    // this.sendingComplete();
    const subject = 'BBMO Support';
    let body = form['message'].value.trim();

    const logs = localStorage.getItem('logs') || '';
    body = body + '\n\n' + logs;

    const encodedSubject = encodeURIComponent(subject);
    const encodedBody = encodeURIComponent(body);

    const constructedUrl = `mailto:support@singularsound.com?subject=${encodedSubject}&body=${encodedBody}`;
    window.open(constructedUrl, '_blank').focus();
  }

  @action
  downloadLogs() {
    downloadLogsUtil();
  }

  <template>
    <form class="flex flex-col gap-2" {{on "submit" this.sendHelpRequest}}>
      <h1 class="text-xl font-bold">How can we help?</h1>
      <p>Please let us know if you have a question, a suggestion, or need help with
        something. Download the log if reporting a bug and send it to
        support@singularsound.com.</p>
      <p>We’ll email you a reply (usually within 2-3 days).</p>

      {{#if this.error}}
        <p class="text-red-600">{{this.error}}</p>
      {{/if}}
      <textarea
        name="message"
        class="w-full h-32 p-2 border rounded"
        aria-label="Message"
      ></textarea>
      <Button
        @icon="paper-plane"
        type="submit"
        class="text-white bg-green-600 hover:bg-green-700 p-2"
      >Send</Button>
      <Button
        @icon="download"
        class="text-white bg-green-600 hover:bg-green-700 p-2"
        {{on "click" this.downloadLogs}}
      >Download Log</Button>
    </form>
  </template>
}
declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    HelpPopup: typeof HelpPopupComponent;
  }
}
